export const API_BASE_URL = process.env.API_URL ?? '';
export const AGREEMENTS_API_BASE_URL = process.env.AGREEMENTS_API_URL ?? '';
export const REAL_ESTATE_API_BASE_URL = process.env.REAL_ESTATE_API_URL;
export const APARTMENTS_API_BASE_URL = process.env.APARTMENTS_API_URL ?? '';
